import { Inject, Injectable, Injector } from '@angular/core';
import { of, switchMap } from 'rxjs';
import { Address } from '../models/address.model';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';

@Injectable({
  providedIn: 'root',
})
export class EnderecoApiService extends UtilsBaseApiService<EnderecoApiService> {
  readonly LISTA_DE_ENDERECO = 'listaEnderecos';
  readonly LISTA_DE_ENDERECO_LEAD = 'listaEnderecosLead';

  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector
  ) {
    super('endereco', injector, environment.BASE_API_URL);
  }

  getListaEnderecos(endereco: { SEQCLIENTE: number; pCODIGOCLI: number }) {
    return this.httpClient
      .post<Address[]>(
        `${this.BASE_URL}${this.CONTEXT}/${this.LISTA_DE_ENDERECO}`,
        endereco
      )
      .pipe(
        switchMap((response) => {
          if (response.length <= 0)
            return this.httpClient.post<Address[]>(
              `${this.BASE_URL}${this.CONTEXT}/${this.LISTA_DE_ENDERECO_LEAD}`,
              endereco
            );

          return of(response);
        })
      );
  }
}
